import { render, staticRenderFns } from "./_buttons.vue?vue&type=template&id=2fa96ae2&"
import script from "./_buttons.vue?vue&type=script&lang=ts&"
export * from "./_buttons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fa96ae2')) {
      api.createRecord('2fa96ae2', component.options)
    } else {
      api.reload('2fa96ae2', component.options)
    }
    module.hot.accept("./_buttons.vue?vue&type=template&id=2fa96ae2&", function () {
      api.rerender('2fa96ae2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_showcase/atoms/_buttons.vue"
export default component.exports